import { ReactNode, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import ContentlyNav from '../../../components/common/nav/nav';
import Footer from '../../../components/common/footer/index';
import { fetchPortfolioProfile } from '../portfolioApi';

const APP_DOMAIN = window.location.hostname;

const BodyReset = createGlobalStyle`
  body { margin: 0; }
`;

const Wrapper = styled.div`
  min-height: 100vh;
  background: #fff;
`;

const TopBar = styled.div`
  border-bottom: 1px solid #e6e8eb;
  padding: 12px 0;
  text-align: center;
`;

const ViewPortfolioBtn = styled.a`
  display: inline-block;
  padding: 6px 16px;
  border: 1px solid #5bc0be;
  color: #5bc0be;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 3px;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    background: #5bc0be;
    color: #fff;
  }
`;

const ContentArea = styled.div`
  max-width: 960px;
  margin: 0 auto;
  padding: 30px 20px 60px;
  display: flex;
  gap: 40px;
`;

const Sidebar = styled.nav`
  width: 120px;
  flex-shrink: 0;
  padding-top: 8px;
`;

const SidebarList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const SidebarItem = styled.li<{ $active: boolean }>`
  margin-bottom: 8px;

  a {
    display: block;
    font-size: 14px;
    color: ${({ $active }) => ($active ? '#333' : '#999')};
    font-weight: ${({ $active }) => ($active ? '600' : '400')};
    text-decoration: none;
    padding: 4px 0;

    &:hover {
      color: #333;
    }
  }
`;

const MainContent = styled.main`
  flex: 1;
  min-width: 0;
`;

interface EditPortfolioLayoutProps {
  children: ReactNode;
}

export default function EditPortfolioLayout({ children }: EditPortfolioLayoutProps) {
  const location = useLocation();
  const isProfile =
    location.pathname.includes('/portfolio/edit') ||
    location.pathname.includes('/portfolio/profile') ||
    location.pathname.includes('/register/contact') ||
    location.pathname.includes('/register/bio') ||
    location.pathname.includes('/register/social');
  const isProjects =
    location.pathname.includes('/portfolio/projects') ||
    location.pathname.includes('/register/projects');

  const [portfolioUrl, setPortfolioUrl] = useState<string>('/');

  useEffect(() => {
    fetchPortfolioProfile()
      .then(profile => {
        if (profile.username) {
          setPortfolioUrl(`//${profile.username}.${APP_DOMAIN}/`);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <Wrapper>
      <BodyReset />
      <ContentlyNav />
      <TopBar>
        <ViewPortfolioBtn href={portfolioUrl}>View portfolio</ViewPortfolioBtn>
      </TopBar>
      <ContentArea>
        <Sidebar>
          <SidebarList>
            <SidebarItem $active={isProfile}>
              <a href="/portfolio/edit?from_portfolio=true">Profile</a>
            </SidebarItem>
            <SidebarItem $active={isProjects}>
              <a href="/portfolio/projects">Projects</a>
            </SidebarItem>
          </SidebarList>
        </Sidebar>
        <MainContent>{children}</MainContent>
      </ContentArea>
      <Footer />
    </Wrapper>
  );
}
